// React
import React, { useEffect } from 'react';

// Packages
import t from 'prop-types';
import cc from 'classcat';

// Utilities

import { useInitiativeDataStore, useLayoutStore } from 'utilities/store';
import { useResponsive } from 'utilities/hooks';

const ReportLayoutComponent = ({ children, pageProps }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const {
        setSecondaryNavigationActive,
        setSecondaryNavigationAnimationOnly,
        setMainNavigationWide,
        setMainNavigationActive,
    } = useLayoutStore();

    const { utilities } = useInitiativeDataStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const bp = useResponsive();

    // ///////////////////
    // DATA
    // ///////////////////

    const smallBps = ['2xs', 'xs', 'sm', 'md'];
    const largeBps = ['lg', 'xl', '2xl', '3xl'];

    // ///////////////////
    // EFFECTS
    // ///////////////////

    useEffect(() => {
        if (utilities.initiative.get().Id) {
            setMainNavigationWide(false);
            setSecondaryNavigationActive(true);
            setSecondaryNavigationAnimationOnly(false);
        } else {
            setMainNavigationWide(false);
            setSecondaryNavigationActive(false);
        }
        setSecondaryNavigationAnimationOnly(false);
    }, [utilities.initiative.get().Id]);

    useEffect(() => {
        if (utilities.initiative.get().Id) {
            if (smallBps.includes(bp)) {
                setSecondaryNavigationActive(false);
                setMainNavigationActive(false);
            }
            if (largeBps.includes(bp)) {
                setSecondaryNavigationActive(true);
                setMainNavigationActive(true);
            }
        }
    }, [bp, utilities.initiative.get().Id]);

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            <div
                className={cc([
                    'flex justify-center mt-header',
                    {
                        'lg:ml-nav-combined': utilities.initiative.get().Id,
                    },
                ])}>
                <div className="w-full max-w-[900px] page-mx">{children}</div>
            </div>
        </>
    );
};

ReportLayoutComponent.propTypes = {
    pageProps: t.object,
};

ReportLayoutComponent.defaultProps = {
    pageProps: {},
};

export default ReportLayoutComponent;
